<template>
  <div>
    <div class="row">
      <label class="col-9 head-label">Options</label>
      <div class="col-3 add-option">
        <sc-button
          variant="secondary"
          size="sm"
          @click="handleClickAddOption"
          :disabled="hasAddExtraOption || !hasOptionSwitch"
          >เพิ่ม option เสริม</sc-button
        >
      </div>
    </div>
    <div
      class="option-group"
      v-for="(option, index) in serviceOptions"
      :key="index"
    >
      <div class="row">
        <div class="col-9 mt-4">
          <div v-if="index === 0">
            <label class="label mb-2">Title (option หลัก)</label>
          </div>
          <div v-else>
            <label class="label mb-2">Title (option เสริม)</label>
          </div>
          <el-input
            class="mb-3"
            type="text"
            :value="option.title"
            @input="handleInputOption(index, $event)"
            :disabled="disabled || !hasOptionSwitch"
            :readonly="isShowOptions"
          ></el-input>
        </div>
        <div class="text-right col-3">
          <sc-button
            v-if="!disabled"
            :disabled="
              option.is_show_delete_option !== 'hasOption' || !hasOptionSwitch
            "
            variant="danger"
            class="btn-delete"
            @click="handleClickRemoveOption(index)"
            :readonly="isShowOptions"
            >ลบ</sc-button
          >
        </div>
      </div>
      <!-- <label class="label mb-2" v-show="!isEmptyVariants(option.variants)"
        >Variants (ใส่ได้ไม่เกิน 40 ตัวอักษร)</label
      > -->
      <div
        class="row mb-3 input"
        v-for="(variant, variantIndex) in option.variants"
        :key="`${index}-${variantIndex}`"
      >
        <div class="col-3 ml-3 mt-2">
          <label class="label-Variant"
            >{{ variantIndex + 1 }}. Variants ({{
              variant.title ? variant.title.length : 0
            }}/40)</label
          >
          <el-input
            type="text"
            :value="variant.title"
            @input="handleInputVariant(index, variantIndex, 'title', $event)"
            :disabled="disabled || !hasOptionSwitch"
            :readonly="isShowOptions"
            :maxlength="40"
          ></el-input>
        </div>
        <div class="col-3 ml-3 mt-2" v-if="isShowMaterialCode">
          <label class="label-Variant">Material Code</label>
          <material-selector
            v-model="variant.material_code"
            :disabled="disabled || !hasOptionSwitch"
            @unitName="handleInputVariant(index, variantIndex, 'unit_name', $event)"
          ></material-selector>
        </div>
        <div class="col-2 ml-3 mt-2" v-if="isShowMaterialCode">
          <label class="label-Variant">จำนวน{{ variant.unit_name }}</label>
          <material-quantity-selector
            v-model="variant.material_quantity"
            :disabled="disabled || !hasOptionSwitch"
          ></material-quantity-selector>
        </div>
        <div class="col-1 checkbox-variant">
          <el-checkbox
            class="checkbox center"
            @input="
              handleInputVariant(index, variantIndex, 'is_out_of_stock', $event)
            "
            :disabled="!hasOptionSwitch"
            :value="variant.is_out_of_stock"
            >หมดสต๊อก</el-checkbox
          >
        </div>
        <div class="col-1 checkbox-variant">
          <el-checkbox
            class="checkbox center"
            @input="
              handleInputVariant(index, variantIndex, 'is_not_sale', $event)
            "
            :disabled="!hasOptionSwitch"
            :value="variant.is_not_sale"
            >ไม่ขาย</el-checkbox
          >
        </div>
        <div class="col-1 text-right checkbox-variant">
          <sc-button
            v-if="!disabled"
            :disabled="
              variant.is_show_delete_option !== 'hasOption' || !hasOptionSwitch
            "
            variant="danger"
            class="btn-delete"
            @click="handleClickRemoveVariant(index, variantIndex)"
            >ลบ</sc-button
          >
        </div>
      </div>
      <div class="row" v-if="!disabled">
        <div class="offset-4 col-5">
          <sc-button
            class="w-100"
            @click="handleClickAddVariant(index)"
            :disabled="isShowOptions || !hasOptionSwitch"
            >เพิ่ม Variant</sc-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import { Input, Select, Option, Checkbox } from "element-ui";
import { isNil, isEmpty } from "ramda";
import { uuid } from "vue-uuid";
import materialSelector from "@/lib/components/materialSelector";
import materialQuantitySelector from "@/lib/components/materialQuantitySelector";

export default {
  components: {
    ScButton,
    ElInput: Input,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
    materialSelector,
    "material-quantity-selector": materialQuantitySelector
  },
  props: ["value", "disabled"],
  data() {
    return {
      isShowOption: false,
      oldServiceOptions: null,
    };
  },
  computed: {
    serviceOptions() {
      return this.value.serviceOptions;
    },
    hasDeleteOption() {
      return this.value.hasDeleteOption;
    },
    hasAddExtraOption() {
      return this.hasAddOptional();
    },
    isShowOptions() {
      return this.isShowOption;
    },
    hasOptionSwitch() {
      return this.value.hasOptionSwitch;
    },
    isShowMaterialCode() {
      return this.value.sapServiceType === 'NORMAL';
    }
  },
  methods: {
    hasAddOptional() {
      return this.value.serviceOptions.some((_, index) => index > 0);
    },
    handleClickRemoveOption(index) {
      let serviceOptions;

      if (index === 0) {
        if (!confirm("หากลบ Option หลัก ข้อมูล Option และราคาทุนจะหายไป")) {
          return;
        }
        serviceOptions = [
          {
            id: uuid.v4(),
            title: "",
            extra_option: false,
            is_show_delete_option: "hasOption",
            variants: [
              {
                variant_id: uuid.v4(),
                title: "",
                is_out_of_stock: false,
                is_not_sale: false,
                is_show_delete_option: "hasOption",
                material_code: null,
                material_quantity: null,
                unit_name: null
              },
              {
                variant_id: uuid.v4(),
                title: "",
                is_out_of_stock: false,
                is_not_sale: false,
                is_show_delete_option: "hasOption",
                material_code: null,
                material_quantity: null,
                unit_name: null
              },
            ],
          },
        ];

        this.$emit("setEmptyServiceOptionCosts");
      } else {
        serviceOptions = this.value.serviceOptions.filter(
          (_, i) => index !== i
        );
      }

      this.$emit("input", serviceOptions);
    },
    handleClickRemoveVariant(optionIndex, variantIndex) {
      const serviceOptions = this.value.serviceOptions.map((option, oIndex) =>
        optionIndex === oIndex
          ? {
              ...option,
              variants: option.variants.filter(
                (_, vIndex) => vIndex !== variantIndex
              ),
            }
          : option
      );

      this.$emit("input", serviceOptions);
    },
    handleClickAddVariant(optionIndex) {
      const serviceOptions = this.value.serviceOptions.map((option, index) =>
        optionIndex === index
          ? {
              ...option,
              variants: [
                ...option.variants,
                {
                  variant_id: uuid.v4(),
                  title: "",
                  is_out_of_stock: false,
                  is_not_sale: false,
                  is_show_delete_option: "hasOption",
                  material_code: null,
                  material_quantity: null,
                  unit_name: null
                }
              ]
            }
          : option
      );

      this.$emit("input", serviceOptions);
    },
    handleClickAddOption() {
      this.$emit("input", [
        ...this.value.serviceOptions,
        {
          id: uuid.v4(),
          title: "",
          extra_option: true,
          is_show_delete_option: "hasOption",
          variants: [
            {
              variant_id: uuid.v4(),
              title: "",
              is_out_of_stock: false,
              is_not_sale: false,
              is_show_delete_option: "hasOption",
              material_code: null,
              material_quantity: null,
              unit_name: null,
              code_description_unit: null
            }
          ]
        }
      ]);
    },
    handleInputOption(index, event) {
      const serviceOptions = this.value.serviceOptions.map((option, i) =>
        i === index ? { ...option, title: event } : option
      );

      this.$emit("input", serviceOptions);
    },
    handleInputVariant(optionIndex, variantIndex, name, event) {
      this.$emit("isCheckCombineOption", true);

      if (name === "title" && event && event.length > 40) {
        return;
      }
      
      let serviceOptions
      if (name === "unit_name") {
        serviceOptions = this.value.serviceOptions.map((option, index) =>
          optionIndex === index
            ? {
                ...option,
                variants: option.variants.map((variant, vIndex) =>
                  variantIndex === vIndex
                    ? {
                      ...variant,
                      unit_name: event.unitName,
                      code_description_unit: event.codeDescriptionUnit
                    }
                    : variant
                ),
              }
            : option
        );  
      } else {
        serviceOptions = this.value.serviceOptions.map((option, index) =>
          optionIndex === index
            ? {
                ...option,
                variants: option.variants.map((variant, vIndex) =>
                  variantIndex === vIndex
                    ? { ...variant, [name]: event }
                    : variant
                ),
              }
            : option
        );
      }

      this.$emit("input", serviceOptions);
    },
    handleClickEditOption() {
      this.isShowOption = false;
      this.oldServiceOptions = this.value.serviceOptions;
    },
    handleClickResetOption() {
      this.isShowOption = true;
      const serviceOptions = this.oldServiceOptions;

      this.$emit("input", serviceOptions);
    },
    isEmptyVariants(variants) {
      return isEmpty(variants);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.input {
  margin-bottom: 17px;
}

.checkbox {
  margin-top: 10px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.option-group {
  padding: 20px 30px;
  margin-bottom: 15px;
  border: $border;

  &:nth-child(2n) {
    background: #ddd;
  }
}

.option {
  margin-bottom: 10px;
  padding: 0px;
}

.edit-option {
  margin-bottom: 10px;
  text-align: left;
}

.add-option {
  margin-bottom: 10px;
  text-align: right;
}

.head-label {
  margin-bottom: 5px;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.label-Variant {
  display: block;

  line-height: 1.6;
  font-size: 1rem;
}

.checkbox-variant {
  margin-top: 43px ;
}
</style>




// WEBPACK FOOTER //
// src/features/subscriptions/modules/services/components/ServiceOptionEditor.vue